import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ScrollTop from "./components/third-party/ScrollTop";
import { AuthProvider } from "./context/AuthContext"; // Correct context path
import { trackPageView } from "./utils/ga";
import AppRoutes from "./app/AppRoutes";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <AuthProvider>
      <ScrollTop>
        <AppRoutes />
      </ScrollTop>
    </AuthProvider>
  );
};

export default App;
